import type { JobStatus } from '../types';

export type JobStatusFetcher = (_jobId: string) => Promise<JobStatus>;

export function pollJobStatus(
  jobId: string,
  getJobStatusFn: JobStatusFetcher,
  onSuccess: (_status: JobStatus) => void,
  onError: (_message: string) => void,
  onUpdate?: (_status: JobStatus) => void,
  timeoutMs = 300000
): () => void {
  let intervalId: ReturnType<typeof setInterval> | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const cleanup = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  intervalId = setInterval(async () => {
    try {
      const status = await getJobStatusFn(jobId);
      onUpdate?.(status);

      if (status.status === 'completed') {
        cleanup();
        onSuccess(status);
      } else if (status.status === 'failed') {
        cleanup();
        onError(status.error || 'Job failed');
      }
    } catch (err) {
      console.error('Failed to check job status:', err);
    }
  }, 2000);

  if (timeoutMs > 0) {
    timeoutId = setTimeout(() => {
      cleanup();
      onError('Job timed out before completion');
    }, timeoutMs);
  }

  return cleanup;
}
